// @flow

import React, { type Node } from 'react';
import { usePendingIncomingPayment, getOxxoBarcode, getGatewayVoucherCode } from '@tectonics/prs/incoming-payment';
import Voucher from 'react-barcode';
import styled from 'styled-components';

type Props = {|
  title?: Node,
  countryCode?: string,
  paymentTypeCode?: string,
|}

export function DisplayBarcode({ title, countryCode, paymentTypeCode }: Props): Node {
  const incomingPayment = usePendingIncomingPayment();
  // oxxopay has no barcode
  if (paymentTypeCode === 'oxxopay') {
    return (<></>);
  }

  let voucherValue;
  switch(countryCode) {
    case 'MX':
      voucherValue = getOxxoBarcode(incomingPayment);
      break;
    case 'AR':
    case 'GT':
    case 'CR':
    case 'PA':
    case 'SV':
      voucherValue = getGatewayVoucherCode(incomingPayment);
      break;
  }

  return (
    <VoucherContent>
      <VoucherTitle>
        {title}
      </VoucherTitle>
      <VoucherWrapper data-test-id="voucher-code">
        <Voucher
          format="CODE128"
          value={voucherValue}
          displayValue={false}
          height={60}
          margin={0}
          textMargin={0}
        />
      </VoucherWrapper>
    </VoucherContent>
  );
}

const VoucherWrapper = styled.div`
  svg {
    width: 100%;
  }
  @media (min-width: 840px) {
      svg {display: block;}
  }
`;

const VoucherContent = styled.div`
  background-color: #fff;

  margin-right:auto;
  margin-left:auto;
  width: 70%;

  @media screen and (min-width: 800px) {
    border-radius: 10px;
  }
`;

const VoucherTitle = styled.p`
  font-size: 16px;
  margin: 0;
`;
